export default {

    find:    { method: 'get',    url: 'institution_type_rules' },
    current: { method: 'get',    url: 'institution_type_rules/current' },
    create:  { method: 'post',   url: 'institution_type_rules'},
    update:  { method: 'put',    url: 'institution_type_rules/{id}'},
    delete:  { method: 'delete', url: 'institution_type_rules/{id}'}
}
